import {
    FieldInCard,
} from 'app/types/form.types'
import {
    SizeLink, TypeLink,
} from 'app/shared-components/SkyNetLink'
import {
    ContainerStatus,
} from 'app/enums/label.enums'
import {
    OverviewFields,
} from './Overview.types'

const getFields = (
    getAllowedValues: (val: Record<string, string>) => Record<string, string>,
    longTermLeaseLink: string,
): FieldInCard<OverviewFields>[] => {
    return [{
        title: 'SUMMARY',
        fields: [
            {
                name: 'serialNumber',
                componentName: 'InputSingleline',
                labelKey: 'SERIAL_NUMBER',
            },
            {
                name: 'containerStatus',
                componentName: 'EnumSelector',
                allowedValues: getAllowedValues(ContainerStatus),
                labelKey: 'CONTAINER_STATUS',
            },
            {
                name: 'jypId',
                componentName: 'InputSingleline',
                labelKey: 'JYP_ID',
            },
            {
                name: 'containerDescription',
                componentName: 'InputSingleline',
                labelKey: 'CONTAINER_DESCRIPTION',
            },
            {
                name: 'location',
                labelKey: 'LOCATION',
                componentName: 'LocationObjectSelector',
            },
            {
                name: 'containerModel',
                componentName: 'IntegerInput',
                labelKey: 'CONTAINER_MODEL',
            },
            {
                name: 'currentLongTermLeaseNumber',
                componentName: 'SkyNetLink',
                link: longTermLeaseLink,
                type: TypeLink.EXTERNAL,
                size: SizeLink.S,
                labelKey: 'LT_CONTRACT',
            },
        ],
    }]
}

export default getFields
